module.exports = __webpack_public_path__ + "img/02.4263f2c7.png";